import { createFileRoute } from "@tanstack/react-router"
import { validateInstructorSectionSearch } from "@/utils/instructorSectionSearch"
import { queryClient } from "@/queryClient"
import { getCourseOptions, getAssignmentOptions } from "@/client/@tanstack/react-query.gen"
import CourseAssessmentEdit from "@/routes/-pages/CourseAssessmentEdit"
import { runBackendModePrefetch } from "@/utils/routePrefetch"
import { sanitizeRouteParam } from "@/utils/routeParams"

export const Route = createFileRoute("/instructor/course/$courseId/assessment/$assessmentId/edit")({
  validateSearch: validateInstructorSectionSearch,
  loader: ({ params }) => {
    const assessmentId = sanitizeRouteParam(params.assessmentId) ?? ""
    return runBackendModePrefetch(() =>
      Promise.all([
        queryClient.prefetchQuery(getCourseOptions({ path: { course_id: params.courseId } })),
        queryClient.prefetchQuery(getAssignmentOptions({ path: { assignment_id: assessmentId } })),
      ]),
    )
  },
  component: CourseAssessmentEdit,
})
